import { generatePath } from 'react-router-dom';

import { ActivitiesContentType, LESSON_ACTIVITIES } from 'global/constants';
import {
  PUBLIC_ACTIVITIES,
  PUBLIC_ASSESSMENT_ACTIVITIES,
  PUBLIC_LESSON_ACTIVITIES,
} from 'global/public-routes.constants';
import { ExtraSectionIdentifiers } from '../activity-builder.apollo';

export function getPublicUrl({
  slug,
  sectionId,
  contentType,
  version,
  lang,
}: {
  contentType: ActivitiesContentType;
  slug?: string;
  sectionId?: string;
  version?: string | null;
  lang?: string | null;
}) {
  const hasPrefix =
    slug?.startsWith('/lesson') || slug?.startsWith('/assessment');

  return `${generatePath(
    !hasPrefix
      ? contentType === LESSON_ACTIVITIES
        ? PUBLIC_LESSON_ACTIVITIES
        : PUBLIC_ASSESSMENT_ACTIVITIES
      : `:slug/${PUBLIC_ACTIVITIES}`,
    {
      slug: slug || '',
    }
  )}${`?page=${sectionId ? sectionId : ExtraSectionIdentifiers.Introduction}`}${
    version ? `&version=${version}` : ''
  }${lang ? `&lang=${lang}` : ''}`;
}
